let consentRedirectHandler = null;

export function setConsentRedirectHandler(handler) {
  consentRedirectHandler = handler;
}

export function notifyConsentRequired(body) {
  if (typeof consentRedirectHandler === "function") {
    consentRedirectHandler(body);
  }
}
